export default __webpack_public_path__ + "images/aed8eeed9b1923b92b2cc162a6d08d65-airshow_small.webp";